import React from 'react';

const DoubleArrowIcon = ({ width = 10, height = 10, color = 'black', ...rest }) => {
  return (
    <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M5.09087 10.1816L-4.43459e-05 5.09073L5.09087 -0.000177383L5.96587 0.863459L2.36359 4.46573H15.9318L12.3295 0.863459L13.2045 -0.000177383L18.2954 5.09073L13.2045 10.1816L12.3295 9.30664L15.9318 5.71573H2.36359L5.96587 9.30664L5.09087 10.1816Z"
        fill={color}
      />
    </svg>
  );
};

export default DoubleArrowIcon;
